<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
          <div class="card-header card-header-with-button">
            <h5>{{$t('NOTIFICATIONCENTER')}}</h5>
            <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="flex-0-auto mb-3">
                  <div class="buttons-group">
                    <label class="has-float-label mr-2">
                      <b-form-fieldset>
                        <span>{{$t('SEARCH')}}</span>
                        <input class="form-control" placeholder=" " v-model="pagination.query" @keyup.enter="getData()">
                      </b-form-fieldset>
                    </label>
                    <label class="has-float-label mr-2">
                      <b-form-fieldset>
                        <button type="button" class="btn-bis btn-tertiary mtt-2" @click="getData()">
                          {{$t('SEARCH')}}
                        </button>
                      </b-form-fieldset>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body" v-if="data.root == null || !data.root.length">
            <p class="center">{{$t('NODATAFOUND')}}</p>
          </div>

          <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
            <table class="table table-bis">
              <thead>
                <tr>
                  <th>{{$t('ID')}}</th>
                  <th>{{$t('CREATEDBY')}}</th>
                  <th v-if="globals && (globals.groupId === 1 || globals.groupId === 5)">{{$t('USERCOMPANY')}}</th>
                  <th>{{$t('CLIENT')}}</th>
                  <th>{{$t('RECURRINGTYPE')}}</th>
                  <th>{{$t('INTERVAL')}}</th>
                  <th>{{$t('STATUS')}}</th>
                  <th>{{$t('STEP_PERIOD')}}</th>
                  <th>{{$t('ISACTIVE')}}</th>
                  <th>{{$t('ACTION')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in data.root" :key="item.notificationRuleId" class="table-ellipsis">
                  <td>{{ item.notificationRuleId }}</td>
                  <td>{{ formatUser(item) }}</td>
                  <td v-if="globals && (globals.groupId === 1 || globals.groupId === 5)">{{ item.companyName || item.subCompanyName || '-' }}</td>
                  <td>{{ item.client || $t('SELECTALLBUILDINGS') }}</td>
                  <td>{{ formatRecurringType(item.recurringType) }}</td>
                  <td>{{ formatInterval(item) }}</td>
                  <td>
                    <span 
                      v-for="st in getStatusesList(item.jobStatus)" 
                      :key="st" 
                      :class="`badge badge-${getStatusBadgeColor(st)} mr-1`">
                      {{ st.toUpperCase() }}
                    </span>
                  </td>
                  <td>
                    {{ formatDate(item.startDate) }}
                    <span v-if="item.endDate"> - {{ formatDate(item.endDate) }}</span>
                  </td>
                  <td>{{ item.isActive === 1 ? $t('YES') : $t('NO') }}</td>
                  <td class="table-buttons">
                    <b-button type="reset" class="btn-table table-btn-tertiary" @click="showModal(item)">{{$t('EDIT')}}</b-button>
                    <b-button type="reset" class="btn-table table-btn-delete ml-2" @click="deleteRow(item.notificationRuleId)">{{$t('DELETE')}}</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="card-body card-footer-pagination flex-0-auto" v-if="data.root != null && data.root.length">
            <b-pagination
              size="md"
              :total-rows="data.totalCount"
              v-model="pagination.currentPage"
              :per-page="pagination.limit">
            </b-pagination>
          </div>
        </div>
      </div>
    </div>

    <notification-form v-model="formView" @close="getData()"></notification-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Api from '@/api/notification_center/NotificationRule.js';
import NotificationForm from './Form.vue';
import localTranslate from '../../helpers/local_trans';

export default {
  name: 'NotificationCenterWin',
  components: {
    NotificationForm,
  },
  data() {
    return {
      data: {},
      formView: null,
      searchTimeout: false,
      pagination: {
        query: '',
        currentPage: 1,
        limit: 25,
      },
    };
  },
  computed: {
    ...mapGetters(['globals']),
  },
  created() {
    this.getData();
  },
  methods: {
    trans(key) {
      return localTranslate(this.globals.langId, key);
    },
    formatUser(item) {
      if (item && (item.userName || item.userSurname)) {
        return `${item.userName || ''} ${item.userSurname || ''}`.trim();
      }
      return '-';
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const parts = dateStr.split('T')[0].split('-');
      if (parts.length === 3) {
        return `${parts[2]}.${parts[1]}.${parts[0]}.`;
      }
      return dateStr;
    },
    formatRecurringType(type) {
      switch (type) {
        case 'days': return this.$i18n.t('DAYS');
        case 'weeks': return this.$i18n.t('WEEKS');
        case 'months': return this.$i18n.t('MONTHS');
        case 'years': return this.$i18n.t('YEARS');
        case 'day_of_week': return this.$i18n.t('DAYOFWEEK');
        case 'day_of_month': return this.$i18n.t('DAYOFMONTH');
        default: return type || '-';
      }
    },
    formatInterval(item) {
      if (!item.interval) return '-';
      if (item.recurringType === 'day_of_week') {
        const dayNames = {
          '1': this.$i18n.t('MONDAY'),
          '2': this.$i18n.t('TUESDAY'),
          '3': this.$i18n.t('WEDNESDAY'),
          '4': this.$i18n.t('THURSDAY'),
          '5': this.$i18n.t('FRIDAY'),
          '6': this.$i18n.t('SATURDAY'),
          '7': this.$i18n.t('SUNDAY'),
        };
        return item.interval.split(',').map(d => dayNames[d.trim()] || d).join(', ');
      }
      return item.interval;
    },
    getStatusesList(jobStatusStr) {
      if (!jobStatusStr) return [];
      return jobStatusStr.split(',').map(s => s.trim()).filter(Boolean);
    },
    getStatusBadgeColor(status) {
      switch (status) {
        case 'finished': return 'success';
        case 'partialyfinished': return 'info';
        case 'canceled': return 'danger';
        case 'overdue': return 'warning';
        default: return 'secondary';
      }
    },
    async getData() {
      try {
        const params = {
          ...this.pagination,
          start: (this.pagination.currentPage - 1) * this.pagination.limit,
        };
        const data = await Api.selectRow(params);
        if (data.error && data.error === true) {
          throw data;
        }
        this.data = data;
      } catch (error) {
        this.$notify.notice(error);
      }
    },
    showModal(item) {
      this.formView = item ? { ...item } : {};
    },
    async deleteRow(id) {
      const me = this;
      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        async btnAction() {
          const data = await Api.deleteRow({ id });
          me.$notify.notice(data);
          me.getData();
        },
      });
    },
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        if (this.searchTimeout !== false) {
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
          this.getData();
          this.searchTimeout = false;
        }, 300);
      },
    },
  },
  computed: {
    ...mapGetters(['globals']),
  },
};
</script>
